import { render } from "./LocalizacoesList.vue?vue&type=template&id=9c41ac0a&scoped=true"
import script from "./LocalizacoesList.vue?vue&type=script&lang=js"
export * from "./LocalizacoesList.vue?vue&type=script&lang=js"

import "./LocalizacoesList.vue?vue&type=style&index=0&id=9c41ac0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c41ac0a"]])

export default __exports__